import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"
import { Colors } from "styles/app-styles"

const PropertyList_s = styled.div`
  .p-paginator {
    bottom: 30px;
  }

  ${DataTable_s}{
    svg {
      width: 16px;
      margin-left: 5px;
      vertical-align: middle;
      &.mf-icon {
        margin-left: 6px;
        width: 14px;
      }
      .r-svg {
        fill: ${Colors.blackPearl};
      }
    }

    > .p-datatable > .p-datatable-header {
      padding: 0;
    }

    div.p-datatable-scrollable-view.p-datatable-unfrozen-view {
      width: calc(100vw - 45px);
    }

    .p-datatable-scrollable-view.p-datatable-frozen-view .p-datatable-scrollable-header-table {
      width: 265px;
    }
  }
`

export default PropertyList_s